import _Object$keys from 'babel-runtime/core-js/object/keys';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { addLayoutItem, updateLayoutItem } from '@/api/quick_layout';
import { v2Host } from '@/config/host';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: false
    },
    dialogEditType: {
      type: String,
      default: 'create'
    },
    quickLayoutForm: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      form: {
        layout_type: '',
        name: '',
        thumb_url: '',
        thumb_md5: '',
        file_url: '',
        file_md5: '',
        file_size: 0,
        file_name: ''
      },
      formLabelWidth: '120px',
      coverFileList: [],
      zipFileList: [],
      submitLoading: false
    };
  },

  computed: {
    dialogFormVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.formClearHandle();
        this.$emit('update:visible', val);
      }
    },
    rulesForm: function rulesForm() {
      var rules = {
        name: [{ required: true, message: '请输入名称', trigger: 'change' }],
        layout_type: [{ required: true, message: '请输入分类名称', trigger: 'change' }]
      };
      if (this.dialogEditType === 'create') {
        return _extends({
          thumb_url: [{ required: true, message: '请选择文件', trigger: 'change' }],
          file_url: [{ required: true, message: '请选择文件', trigger: 'change' }]
        }, rules);
      }
      return rules;
    },

    uploadUrl: {
      get: function get() {
        return v2Host + '/upload/file';
      }
    }
  },
  watch: {
    quickLayoutForm: {
      handler: function handler(val) {
        var _this = this;

        if (this.dialogEditType === 'update' && _Object$keys(this.quickLayoutForm).length) {
          this.$nextTick(function () {
            _this.form = _.pick(val, ['layout_type', 'name']);
          });
        }
      },

      deep: true
    }
  },
  methods: {
    fnSuccessCover: function fnSuccessCover(file) {
      if (file.code === 0) {
        this.form.thumb_url = file.data.file_path;
        this.form.thumb_md5 = file.data.md5;
        this.$refs.formRef.validateField('thumb_url');
      } else {
        this.$message.warning(file.msg);
        this.coverFileList = [];
      }
    },
    fnSuccessZip: function fnSuccessZip(file) {
      if (file.code === 0) {
        this.form.file_url = file.data.file_path;
        this.form.file_md5 = file.data.md5;
        this.form.file_size = file.data.file_size;
        this.form.file_name = file.data.origin_name;
        this.$refs.formRef.validateField('file_url');
      } else {
        this.$message.warning(file.msg);
        this.zipFileList = [];
      }
    },
    fnOnUploadError: function fnOnUploadError() {
      this.$message.warning('文件上传出错！');
    },
    fnChangeFile: function fnChangeFile(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    fnClickList: function fnClickList(file) {
      if (file.response && file.response.data && file.response.data.url) {
        window.open(file.response.data.url);
      } else {
        window.open(file.url);
      }
    },
    fnRemoveCover: function fnRemoveCover() {
      this.form.thumb_url = '';
      this.form.thumb_md5 = '';
    },
    fnRemoveZip: function fnRemoveZip() {
      this.form.file_url = '';
      this.form.file_md5 = '';
      this.form.file_size = '';
      this.form.file_name = '';
    },
    submitDialog: function submitDialog() {
      var _this2 = this;

      this.$refs.formRef.validate(function (valid) {
        if (valid) {
          _this2.submitLoading = true;
          if (_this2.dialogEditType === 'create') {
            addLayoutItem(_this2.form).then(function (res) {
              if (res.data.code === 0) {
                _this2.$message.success('添加成功');
                _this2.$emit('updateLayoutList');
              } else {
                _this2.$message.warning(res.data.msg);
              }
              _this2.submitLoading = false;
              _this2.dialogFormVisible = false;
            }).catch(function () {
              _this2.submitLoading = false;
            });
          } else {
            updateLayoutItem(_extends({
              id: _this2.quickLayoutForm.id
            }, _this2.form)).then(function (res) {
              if (res.data.code === 0) {
                _this2.$message.success('更新成功');
                _this2.$emit('updateLayoutList');
              } else {
                _this2.$message.warning(res.data.msg);
              }
              _this2.submitLoading = false;
              _this2.dialogFormVisible = false;
            }).catch(function () {
              _this2.submitLoading = false;
            });
          }
        }
      });
    },
    formClearHandle: function formClearHandle() {
      var _this3 = this;

      this.$parent.dialogEditType = 'create';
      this.$nextTick(function () {
        _this3.$refs.formRef.resetFields();
      });
      this.zipFileList = [];
      this.coverFileList = [];
      this.$parent.quickLayoutForm = {};
    }
  }
};